<template>
	<v-dialog
		:value="value"
		@input="$emit('input', $event)"
		max-width="440"
		persistent
	>
		<v-card>
			<v-card-title class="headline">Cambiar contrasena</v-card-title>

			<v-card-text>
				<v-form ref="form" v-model="valid">
					<v-text-field
						v-model="currentPassword"
						:append-icon="showCurrent ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showCurrent ? 'text' : 'password'"
						label="Contrasena actual"
						outlined
						dense
						:rules="[rules.required]"
						@click:append="showCurrent = !showCurrent"
					/>

					<v-text-field
						v-model="newPassword"
						:append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showNew ? 'text' : 'password'"
						label="Nueva contrasena"
						outlined
						dense
						:rules="[rules.required, rules.min]"
						@click:append="showNew = !showNew"
					/>

					<v-text-field
						v-model="confirmPassword"
						:append-icon="showConfirm ? 'mdi-eye' : 'mdi-eye-off'"
						:type="showConfirm ? 'text' : 'password'"
						label="Confirmar contrasena"
						outlined
						dense
						:rules="[rules.required, rules.match]"
						@click:append="showConfirm = !showConfirm"
					/>
				</v-form>

				<v-alert v-if="error" type="error" dense text class="mb-0">
					{{ error }}
				</v-alert>
			</v-card-text>

			<v-card-actions>
				<v-spacer />
				<v-btn text :disabled="loading" @click="close">Cancelar</v-btn>
				<v-btn
					color="primary"
					:loading="loading"
					:disabled="!valid"
					@click="submit"
				>
					Guardar
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "ChangePasswordDialog",
	props: {
		value: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			valid: false,
			loading: false,
			error: null,
			currentPassword: "",
			newPassword: "",
			confirmPassword: "",
			showCurrent: false,
			showNew: false,
			showConfirm: false,
			rules: {
				required: (v) => !!v || "Este campo es obligatorio",
				min: (v) => (v && v.length >= 8) || "Minimo 8 caracteres",
				match: (v) =>
					v === this.newPassword || "Las contrasenas no coinciden",
			},
		};
	},
	methods: {
		async submit() {
			if (!this.$refs.form.validate()) return;

			this.loading = true;
			this.error = null;

			try {
				const token = window.localStorage.getItem("auth._token.local");
				await this.$axios.put(
					"/user/change-password",
					{
						current: this.currentPassword,
						new: this.newPassword,
						confirm: this.confirmPassword,
					},
					{
						headers: { Authorization: token },
					}
				);
				this.$emit("success");
				this.close();
			} catch (err) {
				const msg =
					err.response && err.response.data && err.response.data.error;
				this.error = msg || "Error al cambiar la contrasena";
			} finally {
				this.loading = false;
			}
		},
		close() {
			this.currentPassword = "";
			this.newPassword = "";
			this.confirmPassword = "";
			this.showCurrent = false;
			this.showNew = false;
			this.showConfirm = false;
			this.error = null;
			this.$emit("input", false);
		},
	},
};
</script>
